import {CustomFieldValueDTO} from './CustomFieldValueDTO';
import {DateTime} from 'luxon';
import {BonificationDTO} from "./BonificationDTO";
import {RecurrenceDTO} from "./RecurrenceDTO";
import {CustomFieldDTO} from "./CustomFieldDTO";
import {WaitingListInfoDTO} from "./WaitingListInfoDTO";

export class InscriptionSentDTO {
  id: number;
  userId: number;

  inscriptionId: number;
  createdAt: DateTime;
  nameValue: string;
  surnameValues: string;
  mailValue: string;
  dniValue: string;
  bonificationId : number | null;
  finalRecurrence: string | null;
  bonification: BonificationDTO;
  recurrence: RecurrenceDTO;
  groupsIds: number[] | null;
  groups: any[] | null;
  files: any[];

  customFields: CustomFieldDTO[];
  customFieldsValues: CustomFieldValueDTO[];

  //Helpers
  showBonificationDocumentInput: boolean;
  bonificationDocumentInvalid: boolean
  bonificationUploaded: boolean;
  rgpdAcceptedDate: string;

  waitingListInfoDTO?: WaitingListInfoDTO;
}
